import script from "./ChatWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatWindow.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./ChatWindow.vue?vue&type=style&index=0&id=0b0d8b7d&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-0b0d8b7d"]])

export default __exports__